import {
  Modal,
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Chip,
  FormHelperText,
  Collapse,
  Autocomplete,
  Checkbox,
  Tooltip,
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  Clear,
  CloseOutlined,
  PersonOutlineOutlined,
  Search,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import DatagridComponent from "../../../../components/datagridComponent";
import VirtualizedAutocomplete from "../../../../components/virtualization/virtualizedAutocomplete";
import { getClienteOptionLabel } from "../../../../components/grupoEconomico/helpers";
import apiCliente from "../../../../services/apiCliente";
export default function ModalAddUserCliente({
  open,
  setOpenModalAddUser = () => {},
  setNewUserClient = () => {},
  createUserCliente = () => {},
  createButton,
  newUserCliente,
  setSnackbar = () => {},
  permissoes,
  clientes = [],
  isInterno = false,
  setSelectedCliente = () => {},
  setSelectedGrupos = () => {},
  selectedGrupos = [],
  selectedCliente = [],
  setIsClientesPermitidos = () => {},
  isClientesPermitidos = false,
  usersErp = [],
  gruposCliente = [],
}) {
  const [showPass, setShowPass] = useState(false);
  const [emailValido, setEmailValido] = useState(false);
  const [Null, setNull] = useState(false);

  const [senhaValid, setSenhaValid] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  const [searchTerm, setSearchTerm] = useState("");
  // Grupo econômico (portal do cliente): empresas visíveis para o novo usuário
  const [empresasGrupo, setEmpresasGrupo] = useState({
    isGrupo: false,
    membros: [],
  });
  const [selectedEmpresas, setSelectedEmpresas] = useState([]);
  const rowsMap = new Map(clientes.map((obj) => [obj.id, obj]));
  const filteredClientes = clientes?.filter((cliente) => {
    const search = searchTerm.toLowerCase();
    return (
      cliente?.nome?.toLowerCase().includes(search) ||
      cliente?.razaoSocial?.toLowerCase().includes(search) ||
      cliente?.nomeFantasia?.toLowerCase().includes(search) ||
      cliente?.cnpj?.includes(search) ||
      cliente.clienteErpId?.toLowerCase().includes(search)
    );
  });

  useEffect(() => {
    if (newUserCliente?.permissao === "ADM") {
      setIsClientesPermitidos(false);
      // ADM sempre enxerga todas as empresas do grupo
      setSelectedEmpresas([]);
    } else {
      setIsClientesPermitidos(true);
    }
  }, [newUserCliente?.permissao]);

  useEffect(() => {
    if (open && !isInterno) {
      getEmpresasGrupo();
    }
  }, [open]);

  const getEmpresasGrupo = async () => {
    try {
      const response = await apiCliente.post("/cliente/find/empresasGrupo");
      setEmpresasGrupo({
        isGrupo: !!response?.data?.isGrupo,
        membros: response?.data?.membros || [],
      });
    } catch (error) {
      console.error("Erro ao buscar empresas do grupo econômico");
    }
  };

  useEffect(() => {
    setNewUserClient((prev) => ({
      ...prev,
      empresaIds: selectedEmpresas?.map((empresa) => empresa?.id) || [],
      empresasSelecionadas: selectedEmpresas || [],
    }));
  }, [selectedEmpresas]);
  const columns = [
    {
      field: "nome",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => {
        return getClienteOptionLabel(params.row);
      },
    },
    // Você pode adicionar outras colunas aqui (CNPJ, etc)
  ];
  useEffect(() => {
    setNewUserClient("");
  }, []);

  useEffect(() => {
    setNewUserClient({
      ...newUserCliente,
      clientesPermitidos: selectedCliente || [],
    });
  }, [selectedCliente]);

  useEffect(() => {
    setNewUserClient({
      ...newUserCliente,
      gruposCliente: selectedGrupos || [],
    });
  }, [selectedGrupos]);

  useEffect(() => {
    if (emailRegex.test(newUserCliente?.email)) {
      setEmailValido(true);
    } else {
      setEmailValido(false);
    }
  }, [newUserCliente?.email]);

  useEffect(() => {
    if (
      newUserCliente?.senha?.length >= 6 &&
      /[a-zA-Z]/.test(newUserCliente?.senha) &&
      /\d/.test(newUserCliente?.senha)
    )
      setSenhaValid(true);
    else setSenhaValid(false);
  }, [newUserCliente?.senha]);
  const getChipColor = (permissaoObj) => {
    if (permissaoObj?.codigoPermissao === "ADM")
      return "chip.main.waitingReview";
    return permissaoObj?.color || theme.palette.colors.gray.medium; // Retorna a cor do objeto ou vazio
  };
  const handleCreateUser = () => {
    if (
      !newUserCliente?.email ||
      !newUserCliente?.login ||
      !newUserCliente?.senha ||
      !newUserCliente?.email ||
      !newUserCliente?.permissao ||
      !emailValido ||
      !senhaValid
    ) {
      setNull(true);
      setSnackbar({
        children: "Necessário preencher todos os campos",
        severity: "error",
      });
    } else {
      if (!isClientesPermitidos) {
        setSelectedCliente([]);
        setSelectedGrupos([]);
      }
      setNull(false);
      createUserCliente();
      handleCancelar();
    }
  };
  const handleCancelar = () => {
    setNewUserClient({
      login: "",
      email: "",
      senha: "",
      permissao: "",
    });
    setOpenModalAddUser(false);
    setNull(false);
    setSearchTerm("");
    setSelectedCliente([]);
    setSelectedGrupos([]);
    setSelectedEmpresas([]);
  };

  return (
    <Modal
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      open={open}
      onClose={handleCancelar}
    >
      <Paper sx={styles.container}>
        <Box sx={styles.containerTitulo}>
          <Typography variant="title" sx={{}}>
            Cadastrar usuário
          </Typography>
          <IconButton onClick={handleCancelar}>
            <CloseOutlined />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={styles.containerForm}>
          <Stack spacing={1} direction="row" width={"100%"}>
            <TextField
              label="Login"
              id="login"
              variant="filled"
              color="primary"
              size="small"
              sx={styles.textfield}
              fullWidth
              autoComplete="off"
              onChange={(e) =>
                setNewUserClient((prev) => ({
                  ...prev,
                  login: e?.target?.value,
                }))
              }
              helperText={
                !newUserCliente?.login && Null
                  ? "Necessário informar um login"
                  : ""
              }
              error={!newUserCliente?.login && Null}
            />
            <TextField
              label="Email"
              id="email"
              variant="filled"
              type="email"
              size="small"
              color="primary"
              sx={styles.textfield}
              fullWidth
              autoComplete="off"
              onChange={(e) =>
                setNewUserClient((prev) => ({
                  ...prev,
                  email: e?.target?.value,
                }))
              }
              helperText={
                (!newUserCliente?.email || !emailValido) && Null
                  ? "Necessário informar um e-mail válido"
                  : ""
              }
              error={(!newUserCliente?.email || !emailValido) && Null}
            />
          </Stack>
          <Divider orientation="horizontal" sx={styles.divider} />
          <Stack spacing={1} direction="row" width={"100%"}>
            <TextField
              autoComplete="off"
              name="senha"
              label="Senha"
              size="small"
              variant="filled"
              color="primary"
              sx={styles.textfield}
              fullWidth
              type={showPass ? "text" : "password"}
              onChange={(e) =>
                setNewUserClient((prev) => ({
                  ...prev,
                  senha: e?.target?.value,
                }))
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      onClick={() => setShowPass((event) => !event)}
                    >
                      {showPass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              helperText={
                (!newUserCliente?.senha || !senhaValid) && Null
                  ? "A senha precisa ter no mínimo 6 digítos, uma letra e um número."
                  : ""
              }
              error={(!newUserCliente?.senha || !senhaValid) && Null}
            />

            <FormControl
              variant="filled"
              size="small"
              sx={{ ...styles.TextField, minWidth: 200 }}
              fullWidth
              // Corrigido: removido o "Null" que causava erro e centralizado o erro no state
              error={!newUserCliente?.permissao && Null}
            >
              <InputLabel>Permissão</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={newUserCliente?.permissao || ""}
                label="Permissão"
                onChange={(event) => {
                  setNewUserClient((prev) => ({
                    ...prev,
                    permissao: event.target.value,
                  }));
                }}
                // Renderiza o Chip quando houver valor selecionado
                renderValue={(selected) => {
                  const pObj = permissoes.find(
                    (p) => p.codigoPermissao === selected,
                  );

                  return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      <Chip
                        label={selected.toUpperCase()}
                        size="small"
                        sx={{
                          ...styles.chipPermissao,
                          backgroundColor: getChipColor(pObj),
                        }}
                      />
                    </Box>
                  );
                }}
              >
                {Array.isArray(permissoes) &&
                  permissoes.map((permissao) => (
                    <MenuItem
                      key={permissao.id}
                      value={permissao.codigoPermissao}
                      sx={styles.menuItemPermissao}
                    >
                      <Chip
                        label={permissao.codigoPermissao.toUpperCase()}
                        size="small"
                        sx={{
                          ...styles.chipMenuItemPermissao,
                          backgroundColor: getChipColor(permissao),
                        }}
                      />
                    </MenuItem>
                  ))}
              </Select>
              {!newUserCliente?.permissao && Null && (
                <FormHelperText>
                  Necessário informar uma permissão
                </FormHelperText>
              )}
            </FormControl>
          </Stack>

          {!isInterno &&
            empresasGrupo?.isGrupo &&
            newUserCliente?.permissao !== "ADM" && (
              <>
                <Divider orientation="horizontal" sx={styles.divider} />
                <Autocomplete
                  multiple
                  size="small"
                  options={empresasGrupo?.membros || []}
                  value={selectedEmpresas || []}
                  disableCloseOnSelect
                  limitTags={2}
                  getLimitTagsText={(more) => `+${more}`}
                  onChange={(event, newValue) => {
                    setSelectedEmpresas(newValue);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.id) === String(value?.id)
                  }
                  getOptionLabel={(option) =>
                    option?.nome || ""
                  }
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option?.nome || ""}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="filled"
                      size="small"
                      label="Empresas visíveis"
                      helperText="Deixe vazio para ver todas as empresas do grupo"
                    />
                  )}
                />
              </>
            )}

          <Divider orientation="horizontal" sx={styles.divider} />
          {isInterno && (
            <>
              {erp === "HUBSOFT" && (
                <>
                  <VirtualizedAutocomplete
                    size="small"
                    options={usersErp}
                    /*  disabled={loadingParams || loadingCreateTicket}
                value={usuariosSelecionados} */
                    /* isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option?.name || ""}  */
                    onChange={(event, value) => {
                      setNewUserClient((prev) => ({
                        ...prev,
                        userErpId: value?.id,
                      }));
                    }}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        variant="filled"
                        label="Usuário ERP"
                      />
                    )}
                  />
                  <Divider orientation="horizontal" sx={styles.divider} />
                </>
              )}
              <Stack spacing={1} direction="row" width={"100%"}>
                <Collapse
                  sx={{ width: "100%" }}
                  in={isClientesPermitidos}
                  timeout={400}
                  unmountOnExit
                >
                  <Box sx={styles.boxClientesPermitidos}>
                    <Box sx={styles.containerClientesPermitidos}>
                      <Box>
                        <Box sx={styles.titleClientesPermitidos}>
                          <PersonOutlineOutlined sx={{ fontSize: "22px" }} />
                          <Typography sx={{ fontWeight: "bold" }}>
                            Clientes permitidos
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "12px",
                            opacity: 0.5,
                          }}
                        >
                          Caso não selecione nenhum cliente, o usuário terá
                          acesso a todos os clientes.
                        </Typography>
                      </Box>

                      {/* Campo de Busca */}
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder="Buscar cliente."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ minWidth: "300px" }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search fontSize="small" />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              {searchTerm && (
                                <IconButton
                                  size="small"
                                  onClick={() => setSearchTerm("")}
                                >
                                  <Clear fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>

                    <Paper variant="outlined" sx={styles.paperDatagrid}>
                      <DatagridComponent
                        options={{
                          checkboxSelection: true,
                          onRowSelectionModelChange: (currentSelectionIds) => {
                            const previouslySelected = selectedCliente || [];

                            // 1. Pegamos os IDs da lista que está visível no momento
                            const visibleIds = filteredClientes.map(
                              (c) => c.id,
                            );

                            // 2. Mantemos quem já estava selecionado mas NÃO está aparecendo na busca atual
                            const itemsNotVisible = previouslySelected.filter(
                              (item) => !visibleIds.includes(item.id),
                            );

                            // 3. Pegamos os IDs selecionados que estão na tela e buscamos o objeto no Map
                            const itemsNewlySelected = currentSelectionIds
                              ?.filter((id) => visibleIds.includes(id))
                              ?.map((id) => rowsMap.get(id))
                              ?.filter(Boolean); // <--- IMPORTANTE: Remove qualquer item null/undefined

                            // 4. Atualizamos o estado unindo os dois grupos
                            setSelectedCliente([
                              ...itemsNotVisible,
                              ...itemsNewlySelected,
                            ]);
                          },
                          rowSelectionModel: selectedCliente?.map((c) => c?.id),
                          disableRowSelectionOnClick: true,
                        }}
                        rows={filteredClientes || []}
                        columns={columns}
                      />
                    </Paper>
                    {erp === "HUBSOFT" && (
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={gruposCliente || []}
                        value={selectedGrupos || []}
                        disableCloseOnSelect
                        limitTags={2}
                        getLimitTagsText={(more) => `+${more}`}
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            flexWrap: "nowrap",
                            overflow: "hidden",
                            paddingRight: "40px !important",
                          },
                        }}
                        onChange={(event, newValue) => {
                          setSelectedGrupos(newValue);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          String(option.id) === String(value.id)
                        }
                        getOptionLabel={(option) => option?.grupoName || ""}
                        renderTags={(value, getTagProps) => {
                          const numSelected = value.length;
                          const limit = 2;

                          return (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                overflow: "hidden",
                              }}
                            >
                              {value.slice(0, limit).map((option, index) => (
                                <Chip
                                  {...getTagProps({ index })}
                                  key={index}
                                  label={option.grupoName}
                                  size="small"
                                  sx={{ maxWidth: "120px" }}
                                />
                              ))}

                              {numSelected > limit && (
                                <Tooltip
                                  arrow
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "4px",
                                      }}
                                    >
                                      {value.map((option, i) => (
                                        <span
                                          key={i}
                                          style={{
                                            display: "block",
                                            fontSize: "12px",
                                          }}
                                        >
                                          • {option.grupoName}
                                        </span>
                                      ))}
                                    </div>
                                  }
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "gray",
                                      whiteSpace: "nowrap",
                                      cursor: "pointer", // Indica que é interagível
                                      fontWeight: 500,
                                    }}
                                  >
                                    +{numSelected - limit} selecionados
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                          );
                        }}
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={key} {...optionProps}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option?.grupoName}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            size="small"
                            label="Grupo de clientes"
                            sx={{
                              ...styles.TextField,
                              "& .MuiInputBase-input": {
                                minWidth: "20px !important",
                                width: "0px !important",
                                flexGrow: 1,
                              },
                            }}
                          />
                        )}
                      />
                    )}
                  </Box>
                </Collapse>
              </Stack>
            </>
          )}
        </Box>
        <Box sx={styles.containerButtons}>
          <Button
            disabled={createButton}
            variant="contained"
            size="large"
            sx={{ mr: 2, borderRadius: "10px", height: 40 }}
            onClick={handleCreateUser}
          >
            Cadastrar
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
}
